/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ bundle: NonNullable<unknown> }} Receipt_Timeline_StorageInputs */



/**
* | output |
* | --- |
* | "Storage {bundle}" |
*
* @param {Receipt_Timeline_StorageInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const receipt_timeline_storage = /** @type {((inputs: Receipt_Timeline_StorageInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Receipt_Timeline_StorageInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Speicher ${i?.bundle}`)
	return /** @type {LocalizedString} */ (`Storage ${i?.bundle}`)
});